import { TransitionService } from "@uirouter/angularjs";
import { IRunBlockRootScope } from "@app/interfaces/IRunBlockRootScope";
import { ApplicationTheme } from "@app/main/modules/foundation/_enums/application-theme";
import * as angular from "angular";

export class ThemeServiceNew {
    private static readonly localStorageKey = "theme";

    static $inject = ["$transitions", "$rootScope"];

    constructor(
        private readonly $transitions: TransitionService,
        private readonly $rootScope: IRunBlockRootScope
    ) {
        const initTheme = this.getLocalStorageTheme() || ApplicationTheme.Default;
        this.setTheme(initTheme);

        this.$transitions.onEnter({}, () => this.handleTransition());
    }

    //--

    private setTheme(themeKey: ApplicationTheme): void {
        localStorage.setItem(ThemeServiceNew.localStorageKey, themeKey.toString());
    }

    private handleTransition(): void {
        const currentUser = angular.copy(this.$rootScope.currentUser);
        const localStorageTheme = this.getLocalStorageTheme();

        if (!currentUser && !localStorageTheme) {
            this.setTheme(ApplicationTheme.Default);
            return;
        }

        if (!currentUser && localStorageTheme) {
            this.setTheme(localStorageTheme);
            return;
        }

        const currentMapping = currentUser.CurrentAccountUserMapping;

        if (!currentMapping || !currentMapping?.resellers || currentMapping?.resellers.length === 0) {
            this.setTheme(ApplicationTheme.Default);
            return;
        }

        const theme = currentMapping.resellers[0].Theme
        this.setTheme(theme);
    }

    private getLocalStorageTheme(): ApplicationTheme | null {
        const theme = localStorage.getItem(ThemeServiceNew.localStorageKey);

        if (!theme) {
            return null;
        }

        return parseInt(theme) as ApplicationTheme;
    }
}